import cn from 'classnames';
import * as st from './styles.module.scss';

type PT = {
  className?: string;
};
export const PasswordHint = ({ className }: PT) => {
  return (
    <p className={cn(st.passwordHint, className)}>
      *Пароль должен содержать не менее 8 символов, включать буквы в верхнем и нижнем регистре,
      содержать цифры и специальные символы
    </p>
  );
};
